import { all } from "redux-saga/effects";
import { hocKyDangKySaga } from "./hocKyDangKySaga";
import { mucTriNangSaga } from "./mucTriNangSaga";
import { monHocSaga } from "./monHocSaga";
import { khoaSaga } from "./khoaSaga";
import { boMonSaga } from "./boMonSaga";
import { donViHanhChinhSaga } from "./donViHanhChinhSaga";
import { giaoVienSaga } from "./giaoVienSaga";
import { chuDeSaga } from "./chuDeSaga";
import { toChucThiSaga } from "./toChucThiSaga";
import { heSaga } from "./heSaga";

export default function* categorySagaWrapper() {
  yield all([
    hocKyDangKySaga(),
    mucTriNangSaga(),
    monHocSaga(),
    khoaSaga(),
    boMonSaga(),
    donViHanhChinhSaga(),
    giaoVienSaga(),
    chuDeSaga(),
    toChucThiSaga(),
    heSaga(),
  ]);
}
